import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { URL_PAGO } from '../../../core/constants/globals';

@Component({
	selector: 'app-payment-portal-modal',
	standalone: true,
	imports: [DialogModule],
	templateUrl: './payment-portal-modal.component.html',
	styleUrls: ['./payment-portal-modal.component.css']
})
export class PaymentPortalModalComponent {
	@Input() show: boolean = false;
	@Output() hidden = new EventEmitter<boolean>();

	// Payment URLs
	similpayUrl: string = URL_PAGO.SIMIL_PAY;
	avalPayUrl: string = URL_PAGO.AVAL_PAY;

	// Asset paths
	similpayLogo: string = 'assets/img/principal/PSE.png';
	avalPayLogo: string = 'assets/img/principal/aval-pay-center.png';
	rayoLogo: string = 'https://d2kkzfskpa3qm4.cloudfront.net/imagenes/Logo-Rayo-2024.webp';

	// WhatsApp contact URL
	whatsappUrl: string = 'https://api.whatsapp.com/send?phone=573169197373&text=%C2%A1Hola!%20Requiero%20conversar%20con%20un%20asesor.';

	hiddenModal = () => {
		this.hidden.emit(false);
	}

	goToSimilpay = () => {
		window.open(this.similpayUrl, '_blank');
		this.hiddenModal();
	}

	goToAvalPay = () => {
		window.open(this.avalPayUrl, '_blank');
		this.hiddenModal();
	}
}
